<template>
  <div class="Box">
    <News />
    <HomePage />
    <Videos />
  </div>
  <div class="flexRight">
    <FlexRight></FlexRight>
  </div>
</template>

<script>
import News from "./Home/Main/News";
import HomePage from "./Home/Main/HomePage.vue";
import Videos from "./Home/Main/Videos.vue";
import FlexRight from "./Home/FlexRight";
import * as Vue from "vue";
export default {
  name: "Home",
  components: {
    News,
    FlexRight,
    HomePage,
    Videos,
  },
  setup(props, { attrs, slots, emit }) {
    const state = Vue.reactive({});
    return {
      state,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "/src/comment/comment";
.Box {
  position: relative;
}
.flexRight {
  position: fixed;
  right: 10px;
  top: 50%;
  z-index: 100;
}
</style>